/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { createRequestToAttachInvestor } from '../../../redux/actions/investor/attachInvestor';
import { PAMMState } from '../../../redux/reducers/rootReducer';
import { Investor } from '../../../types/investorTypes';
import { Master } from '../../../types/masterTypes';
import { setConnectToMasterConfirmationStatus } from '../../../redux/actions/setMobileMenusStatus';
import style from './ConfirmConnectToMasterMenuMobile.module.css';
import { applyStyles } from '../../../utils/applyStyles';

const ConfirmConnectToMasterMenu: React.FC<any> = ({ onSwipe, onCancel }): JSX.Element => {
  const dispatch = useDispatch();
  const history: History = useHistory();
  const show = useSelector((state: PAMMState) => state.mobileMenusStatusReducer.showConnectToMasterConfirmation);

  const api: string = useSelector((state: PAMMState) => state.configReducer.api);
  const investor: Investor = useSelector((state: PAMMState) => state.investorReducer.investor);
  const master: Master = useSelector((state: PAMMState) => state.masterReducer.master);

  const handleAttach = (): void => {
    dispatch(createRequestToAttachInvestor(api, investor.Id.toString(), master.Id.toString(), history));
    dispatch(setConnectToMasterConfirmationStatus(false));
  };

  return (
    <div
      id="confirm-connect-to-master-menu"
      className={applyStyles([style['menu'], show ? style['show'] : style['hide']])}
      onPointerMove={(event) => onSwipe(event)}
      onPointerCancel={() => onCancel('confirmConnectToMasterMenu')}
    >
      <h6 className={applyStyles([style['title'], 'text-h4-semibold'])}>
        <FormattedMessage id="masterDetails.mobile.connectToThisMaster" />?
      </h6>
      <button type="button" className={applyStyles([style['button'], 'text-h4-semibold'])} onClick={handleAttach}>
        <FormattedMessage id="button.connect" />
      </button>
    </div>
  );
};

export default ConfirmConnectToMasterMenu;
